import React from 'react';
import { SettingsPage } from '../../components/SettingsPage/SettingsPage';
import { SettingsCategory } from '../../config/SettingsCategory';
import { useSettingsPage } from '../../hooks/useSettingsPage';
import { SettingsRenderer } from '../../SettingsProvider/SettingsRenderer';
import { DevicesInfo } from '../../customSettings/DevicesInfo/DevicesInfo';
import { DEVICE_SETTING_IDS } from '../../config/SettingIds';
import { getSettingConfig } from '../../config/SettingsDefinitions';

interface DevicesSettingsPageProps {
	title: string;
	description?: string;
}

export const DevicesSettingsPage: React.FC<DevicesSettingsPageProps> = ({ title }) => {
	const { settingsState, availableSettingIds, handleChangeBySettingId } = useSettingsPage(
		{ category: SettingsCategory.Devices, revertOnError: true }
	);

	// Use SettingsRenderer for all settings
	const renderSetting = (settingId: string) => {
		// Custom rendering for DevicesInfo
		if (settingId === DEVICE_SETTING_IDS.DEVICES_INFO) {
			const config = getSettingConfig(settingId);
			return (
				<DevicesInfo
					key={settingId}
					title={config?.title}
					description={config?.description}
					learnMoreUrl={config?.learnMoreUrl}
					learnMoreText={config?.learnMoreText}
				/>
			);
		}

		return SettingsRenderer({
			settingId,
			settingsState,
			handleChange: handleChangeBySettingId,
		});
	};

	return (
		<SettingsPage
			title={title}
			settings={
				<>
					{/* Dynamically render all available settings */}
					{availableSettingIds.map((settingId) => renderSetting(settingId))}
				</>
			}
		/>
	);
};
